import { render, staticRenderFns } from "./ScoreTracking.vue?vue&type=template&id=0f803b62&"
import script from "./ScoreTracking.vue?vue&type=script&lang=js&"
export * from "./ScoreTracking.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTracking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports